import axios from '@/user/axios.js'
import { config, event, setUserProperties } from '@/ga/user'

const moduleAuth = {
  namespaced: true,
  state: {
    activeUserId: '',
    activeUser: '',
    token: '',
    accounts: [],
    status: ''
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status
  },
  mutations: {
    USER: (state, data) => {
      state.status = 'login'
      state.activeUserId = data.id
      state.activeUser = data.email
    },
    LOGIN: (state, token) => {
      state.status = 'login'
      state.token = token
    },
    LOGOUT: (state) => {
      state.status = 'logout'
      state.token = ''
    }
  },
  actions: {
    sendPasswordResetEmail: (context, { email }) => {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post('/api/password/email', {
            email
          })
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    register: ({ commit }, user) => {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/register', user)
          .then(resp => {
            if (resp.data.success) {
              commit('LOGIN', resp.data.data.token)
              commit('USER', {email:user.email, id:resp.data.data.id})
              config({
                user_id: resp.data.data.id
              })
              // GAのカスタムディメンション用にも登録してあげる
              // GAが用意してるuser_idは管理画面からみれない&フィルタとして使えないため、
              // ubun_user_idというカスタムディメンションを用意してる
              setUserProperties({
                ubun_user_id: resp.data.data.id
              })
              event('sign_up', {
                method: 'Email'
              })
              commit('account/UPDATE_ACCOUNT_INFO', resp.data.data.accounts[0], {root: true})
              commit('account/SET_ACCOUNTS', resp.data.data.accounts, {root: true})
              commit('amcProfile/SET_ACTIVE_AMC_PROFILE', resp.data.data.amcProfiles[0], { root: true })
              commit('amcProfile/SET_AMC_PROFILES', resp.data.data.amcProfiles, { root: true })
            }
            resolve(resp)
          })
          .catch(err => {
            commit('LOGOUT')
            sessionStorage.removeItem('ubunadmin')
            reject(err)
          })
      })
    },
    login: ({ commit }, user) => {
      return new Promise((resolve, reject) => {
        axios.post('/api/login', {
          email: user.email,
          password: user.password
        })
          .then(resp => {
            if (resp.data.success) {
              commit('LOGIN', resp.data.data.token)
              commit('USER', {email:user.email, id:resp.data.data.id})
              config({
                user_id: resp.data.data.id
              })
              // GAのカスタムディメンション用にも登録してあげる
              // GAが用意してるuser_idは管理画面からみれない&フィルタとして使えないため、
              // ubun_user_idというカスタムディメンションを用意してる
              setUserProperties({
                ubun_user_id: resp.data.data.id
              })
              event('login', {
                method: 'Email'
              })
              commit('account/UPDATE_ACCOUNT_INFO', resp.data.data.accounts[0], {root: true})
              commit('account/SET_ACCOUNTS', resp.data.data.accounts, {root: true})
              commit('amcProfile/SET_ACTIVE_AMC_PROFILE', resp.data.data.amcProfiles[0], { root: true })
              commit('amcProfile/SET_AMC_PROFILES', resp.data.data.amcProfiles, { root: true })
            }
            resolve(resp)
          }).catch(err => {
            commit('LOGOUT')
            sessionStorage.removeItem('ubunconsole')
            reject(err)
          })
      })
    },
    checkToken: (context, token) => {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get(`/api/password/reset/${token}`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    resetPassword: (context, data) => {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post('/api/password/reset', data)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    logout: ({commit}) => {
      return new Promise((resolve, reject) => {
        axios.get('/api/logout')
          .then(resp => {
            commit('LOGOUT')
            sessionStorage.removeItem('ubunconsole')
            resolve(resp)
          }).catch(err => {
            commit('LOGOUT')
            sessionStorage.removeItem('ubunconsole')
            reject(err)
          })
      })
    }
  }
}

export default moduleAuth
